$(document).ready(function () {
  $(".banner_slider .banner_list").slick({
    dots: true,
    infinite: true,
    arrows: false,
    speed: 1500,
    slidesToShow: 1,
    adaptiveHeight: true,
  });

  $('.icons-section .marquee-left').marquee({
    direction: 'left',
    duration: 25000,
    delayBeforeStart: 0,
    duplicated: true,
    startVisible: true
  });
  $('.brands-section .marquee-left').marquee({
    direction: 'left',
    duration: 25000,
    delayBeforeStart: 0,
    duplicated: true,
    startVisible: true
  });

  // $('.new_feature_collection .product_list').slick({
  //   dots: false,
  //   infinite: false,
  //   speed: 300,
  //   slidesToShow: 5,
  //   slidesToScroll: 1,
  //   responsive: [
  //     {
  //       breakpoint: 1360,
  //       settings: {
  //         slidesToShow: 4,
  //         slidesToScroll: 1,
  //         infinite: false,
  //         dots: false
  //       }
  //     },
  //     {
  //       breakpoint: 1024,
  //       settings: {
  //         slidesToShow: 3,
  //         slidesToScroll: 1
  //       }
  //     },
  //     {
  //       breakpoint: 768,
  //       settings: {
  //         slidesToShow: 2,
  //         slidesToScroll: 1
  //       }
  //     },
  //     {
  //       breakpoint: 480,
  //       settings: {
  //         slidesToShow: 1,
  //         slidesToScroll: 1
  //       }
  //     }
  //   ]
  // });

  $('.marquee_main .marquee-left').marquee({
    direction: 'left',
    duration: 30000,
    delayBeforeStart: 0,
    gap: 50,
    duplicated: true,
    startVisible: true
  });

  $('.reviews_bg .customer_list').slick({
    dots: false,
    infinite: false,
    speed: 300,
    slidesToShow: 3,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
          infinite: false,
          dots: false
        }
      },
      {
        breakpoint: 992,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 576,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1
        }
      }
    ]
  });

  $('.customer-testimonials-section .testimonial-slider').slick({
    dots: false,
    arrow: true,
    infinite: false,
    speed: 300,
    slidesToShow: 4,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 1199,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 991,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 640,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1
        }
      }
    ]
  });




  function before_after_slider() {
    $(".before_after_results_main .slide_list").slick({
      dots: false,
      infinite: true,
      arrows: true,
      speed: 300,
      slidesToShow: 1,
      adaptiveHeight: true,
    });
  }

  before_after_slider();
  document.addEventListener("shopify:section:load", before_after_slider);

  $(function () {
    $('.faq_title').click(function (j) {

      var dropDown = $(this).closest('.faq_card').find('.faq_panel');
      $(this).closest('.accordion_inner').find('.faq_panel').not(dropDown).slideUp();

      if ($(this).hasClass('active')) {
        $(this).removeClass('active');
      } else {
        $(this).closest('.accordion_inner').find('.faq_title.active').removeClass('active');
        $(this).addClass('active');
      }

      dropDown.stop(false, true).slideToggle();
      j.preventDefault();
    });
  });




  function testimonial_slider_init() {
    $('.testimonial-slider-left-inner').slick({
      slidesToShow: 2,
      slidesToScroll: 1,
      arrows: false,
      infinite: true,
      speed: 700,
      cssEase: 'ease',
      adaptiveHeight: false, responsive: [
        {
          breakpoint: 1280,
          settings: {
            slidesToShow: 1
          }
        },
        {
          breakpoint: 768,
          settings: {
            slidesToShow: 1
          }
        }
      ]
    });

    $('.testimonial-slider-right-inner').slick({
      slidesToShow: 2,
      slidesToScroll: 1,
      arrows: false,
      infinite: true,
      speed: 700,
      cssEase: 'ease',
      adaptiveHeight: false,
      responsive: [
        {
          breakpoint: 1280,
          settings: {
            slidesToShow: 1
          }
        },
        {
          breakpoint: 768,
          settings: {
            slidesToShow: 1
          }
        }
      ]
    });


    // Custom navigation controlling BOTH sliders
    $('.testimonial-next').on('click', function () {
      $('.testimonial-slider-left-inner').slick('slickNext');
      $('.testimonial-slider-right-inner').slick('slickNext');
    });

    $('.testimonial-prev').on('click', function () {
      $('.testimonial-slider-left-inner').slick('slickPrev');
      $('.testimonial-slider-right-inner').slick('slickPrev');
    });

  }
  testimonial_slider_init();
  document.addEventListener("shopify:section:load", testimonial_slider_init);


  // before after page slider
  function before_after_slider_page() {
    $('.before-after-slider-page .custom-slider').slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows: false,
      dots: false
    });

    $('.before-after-slider-page .arrow-prev').click(function () {
      $('.before-after-slider-page .custom-slider').slick('slickPrev');
    });

    $('.before-after-slider-page .arrow-next').click(function () {
      $('.before-after-slider-page .custom-slider').slick('slickNext');
    });
  }

  before_after_slider_page();
  document.addEventListener("shopify:section:load", before_after_slider_page);

});
